export const Entitlements = {
    IpRestrictions: 'Platform.IpRestrictions',
    CustomerManagedKey: 'Platform.CustomerManagedKey',
    Insights: 'Insights.FullMode',
    PlatformSapEnabled: 'Platform.SapEnabled',
    SessionPolicy: 'Platform.SessionPolicy',
    AccessPolicy: 'Platform.AccessPolicy',
    CheckAccess: 'Platform.CheckAccess',
    UserConsent: 'Platform.UserConsentPolicy',
    CustomMailSettings: 'Platform.CustomMailSettings',
    AiTrustLayerByoLlm: 'AITL.BYOLLM',
    AiTrustLayerShowLlmOps: 'AITL.ShowLLMOpsTabs',
    AiTrustLayerShowGovernance: 'AITL.ShowAIGovernanceTab',
    SsoProvisioning: 'Platform.SSOProvisioning',
    EligibleForMultiRegion: 'Platform.EligibleForMultiRegion',
    CanaryTenant: 'Platform.CanaryTenant',
    UIBranding: 'Platform.UIBranding',
    AppTester: 'Ubl.AppTesterNamedUser',
    AppTestDeveloper: 'Ubl.AppTestDevNamedUser',
    EligibleForOrganizationExperience: 'TestCloud.EligibleForOrganizationExperience',
    EligibleForUserExperience: 'TestCloud.EligibleForUserExperience',
    EligibleForResourceCatalogueTags: 'Platform.EligibleForResourceCatalogueTags',
    EligibleForCustomRoles: 'Platform.EligibleForCustomRoles',
    Governance: 'Platform.CanAdminAccessGovernance',
    Relay: 'Platform.RelayEnabled',
    FltEligible: 'Platform.FltEligible',
} as const;

export type Entitlement = typeof Entitlements[keyof typeof Entitlements];
